import React, { useCallback, useContext } from "react";

import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import { Clipboard } from "react-feather";

import { SnackbarContext } from "../../../context/snackbar-context";
import mainStyles from "../../../styles";

interface CopyableIdProps {
  id: string;
  testId?: string;
}

export const CopyableId = ({ id, testId }: CopyableIdProps) => {
  const { copyToClipboard } = useContext(SnackbarContext);
  const theme = useTheme();
  const classes = mainStyles();

  const handleCopy = useCallback(() => {
    copyToClipboard(id);
  }, [copyToClipboard, id]);

  return (
    <Tooltip title="Copy ID">
      <Box
        onClick={handleCopy}
        sx={{
          ...classes.clickable,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
        data-testid={testId}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontFamily: "monospace", wordBreak: "break-all" }}
        >
          {id}
        </Typography>
        <Clipboard color={theme.palette.text.secondary} size="0.875rem" />
      </Box>
    </Tooltip>
  );
};
